/*document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".slide");
  const prevButton = document.querySelector(".prev-slide");
  const nextButton = document.querySelector(".next-slide");
  const progressBar = document.querySelector(".progress-bar");
  let currentSlide = 0;
  const totalSlides = slides.length;

  function updateSlider() {
    const offset = -currentSlide * 100;
    document.querySelector('.slides').style.transform = `translateX(${offset}%)`;

    const progressStep = 100 / totalSlides;
    progressBar.style.width = `${(currentSlide + 1) * progressStep}%`;
  }

  prevButton.addEventListener("click", () => {
    currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
    updateSlider();
  });

  nextButton.addEventListener("click", () => {
    currentSlide = (currentSlide + 1) % totalSlides;
    updateSlider();
  });

  // Initial load
  updateSlider();
});*/
document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".slide");
  const prevButton = document.querySelector(".prev-slide");
  const nextButton = document.querySelector(".next-slide");
  const progressBar = document.querySelector(".progress-bar");
  let currentSlide = 0;
  const totalSlides = slides.length;

  function updateSlider() {
    const offset = -currentSlide * 100;
    document.querySelector('.slides').style.transform = `translateX(${offset}%)`;

    const progressStep = 100 / totalSlides;
    progressBar.style.width = `${(currentSlide + 1) * progressStep}%`;
  }

  prevButton.addEventListener("click", () => {
    if(currentSlide - 1>=0){
      currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
    console.log("pv",currentSlide +" "+totalSlides);
    updateSlider();
    }
    
  });

  nextButton.addEventListener("click", () => {
    
    
    if(currentSlide+1<totalSlides){
      currentSlide = (currentSlide + 1) % totalSlides;
      updateSlider();
    }
    
  });

  // Initial load
  updateSlider();
});